import React, { useState } from 'react';
import SimpleModalRemoteControlled from './SimpleModalRemoteControlled';
import ModalActionButton from './ModalActionButton';
import ModalStartButton from './ModalStartButton';

/**
 * Klasse fuer einen einfachen Dialog mit Ja/Nein Option
 */
export default function DeleteConfirmDialog({
    closeCallback,
    confirmCallback,
    header,
    content,
    cancelButtonText,
    confirmButtonText,
    disabled,
}) {
    const [open, setOpen] = useState(false);

    return (
        <SimpleModalRemoteControlled
            button={(props) => <ModalStartButton buttonIcon='trash' disabled={disabled} onOpen={() => setOpen(true)}/>}
            isOpen={open}
            openCallback={()=>setOpen(true)}
            closeCallback={()=>setOpen(false)}
            header={header}
            content={content}
            actions={(props) => 
            <ModalActionButton 
                submitIcon='trash'
                submitText='common.ok'
                isValidForm={true}
                submitCallback={() => {
                        setOpen(false);
                        if(confirmCallback) confirmCallback();
                    }
                } 
                cancelCallback={() => {
                        setOpen(false);
                        if (closeCallback) closeCallback();
                    }
                }
            />}
        />
    );
}
